export enum Toast {
  error = 'toast-error',
  success = 'toast-success',
  danger = 'danger',
}
